import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../store/slices/authSlice';
import { FaBars, FaBell, FaUserCircle } from 'react-icons/fa';
import { usePageTitle } from '../../context/PageTitleContext';
import './Header.scss';

function Header({ toggleSidebar }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { pageTitle } = usePageTitle();

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get user initials for avatar fallback
  const getUserInitials = () => {
    if (!user?.name) return 'U';
    return user.name.split(' ')
      .map(name => name[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="mobile-menu-btn" onClick={toggleSidebar}>
          <FaBars />
        </button>
        <div className="breadcrumb">
          <span>{pageTitle}</span>
        </div>
      </div>
      <div className="header-right">
        <div className="notifications">
          <button>
            <FaBell />
          </button>
        </div>
        <div className="user-menu" ref={dropdownRef}>
          <button onClick={toggleDropdown}>
            {user?.profilePicture ? (
              <div className="user-avatar">
                <img src={user.profilePicture} alt="Profile" />
              </div>
            ) : user?.name ? (
              <div className="user-avatar user-initials">
                {getUserInitials()}
              </div>
            ) : (
              <FaUserCircle />
            )}
            <span className="user-name">{user?.name || user?.email || 'User'}</span>
          </button>
          {dropdownOpen && (
            <div className="dropdown-menu">
              <ul>
                <li><a href="/profile">My Profile</a></li>
                <li><button onClick={handleLogout} className="logout-button">Logout</button></li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header; 